import { withSentry } from "@sentry/remix";

export const withTelemetry = withSentry;
